import netsHidConsentDialog from './hid-consent-dialog';

export default angular
  .module('app.hidConsentDialog', [])
  .component('netsHidConsentDialog', netsHidConsentDialog);
